import config from '@/config';
import { useUserStore } from '@/stores/user';

const helpCenterHost = () => {
  const { hasFeatureFlag } = useUserStore();
  return hasFeatureFlag('treatwell-brand')
    ? config.helpCenterUrlTreatwell
    : config.helpCenterUrl;
};

const isFullUrl = (value: string) => /^https?:\/\//.test(value);

export const helpCenterUrl = (path = '') =>
  isFullUrl(path) ? path : `${helpCenterHost()}${path}`;

export const helpCenterArticleUrl = (articleId: string | number) => {
  const value = String(articleId);
  return isFullUrl(value) ? value : helpCenterUrl(`/articles/${value}`);
};

// Some collections have a different id on the Treatwell brand help center,
// keyed here by the Salonized collection id.
const treatwellCollectionIds: Record<string, string> = {
  '1515722': '19734229-register',
  '14685': '19734218-calendar',
  '14687': '19734213-customers',
  '14689': '19734239-product-and-stock-management',
  '14690': '19734234-sales-and-invoices',
  '14733': '19734253-online-review-widget',
  '6856279': '19734233-treatwell-pay',
};

export const helpCenterCollectionUrl = (path: string) => {
  const { hasFeatureFlag } = useUserStore();
  if (!hasFeatureFlag('treatwell-brand')) {
    return helpCenterUrl(path);
  }

  const [, salonizedId] = path.match(/^\/collections\/(\d+)-/) || [];
  const treatwellCollection =
    salonizedId && treatwellCollectionIds[salonizedId];

  return helpCenterUrl(
    treatwellCollection ? `/collections/${treatwellCollection}` : path,
  );
};

export const helpCenterSearchUrl = (query: string) =>
  helpCenterUrl(`/?q=${encodeURIComponent(query)}`);
